import { GrowWelcome } from "@/components/Grow/GrowWelcome";
import { createFileRoute } from "@tanstack/react-router";
import { useGrowStore } from "@/state/useGrowStore";

function GrowIndexPage() {
  const { hasConnectedAccounts } = useGrowStore();

  return (
    <GrowWelcome
      onGetStarted={() => {
        if (hasConnectedAccounts) {
          window.location.href = "grow/content-producer";
        } else {
          window.location.href = "grow/profile";
        }
      }}
      hasConnectedAccounts={hasConnectedAccounts}
    />
  );
}

export const Route = createFileRoute("/_app/_auth/grow/")({
  component: GrowIndexPage,
});
